import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_CLIENT_URL ?? `${hostConfig.apiBaseUrl}/client-service`;

class ClientService {
  constructor() {
    this.apiClient = createAxiosInstance(baseUrl);
  }

  async updateClientRegistrationFormFieldsV3(clientId, data) {
    return (
      await this.apiClient.put(baseUrl + "/v3/client-registration-form-field/" + clientId, data, {
        errorContext: "Failed to update client registration form fields",
      })
    )?.data;
  } // updateClientRegistrationFormFieldsV3

  // V3 routes
  async getClientsV3(params) {
    return (
      await this.apiClient.get(baseUrl + "/v3/client", {
        params,
        errorContext: "Failed to get clients",
      })
    )?.data;
  } // getClientsV3

  async getClientV3(clientId) {
    return (
      await this.apiClient.get(baseUrl + "/v3/client/" + clientId, {
        errorContext: "Failed to get client",
        params: { includeClientRegistrationFormFields: true },
      })
    )?.data;
  } // getClientV3

  getClientByOnboardingTokenV3 = async (onboardingToken) => {
    return (
      await this.apiClient.get(baseUrl + "/v3/client/onboarding-token/" + onboardingToken, {
        errorContext: "Failed to find client",
      })
    )?.data;
  }; // getClientByOnboardingTokenV3

  getClientByPersistentOnboardingTokenV3 = async (onboardingToken) => {
    return (
      await this.apiClient.get(
        baseUrl + "/v3/client/onboarding-token-persistent/" + onboardingToken,
        {
          errorContext: "Failed to find client",
        }
      )
    )?.data;
  }; // getClientByPersistentOnboardingTokenV3

  async getClientDropdownV3() {
    return (
      await this.apiClient.get(baseUrl + "/v3/client/dropdown", {
        errorContext: "Failed to get client dropdown",
        silent: true, // don't show error notification for client dropdown
      })
    )?.data;
  } // getClientDropdownV3

  async getSubClientsV3(clientId) {
    return (
      await this.apiClient.get(baseUrl + "/v3/client/subclient/" + clientId, {
        errorContext: "Failed to get subclients",
        silent: true, // don't show error notification for subclients
      })
    )?.data;
  } // getSubClientsV3

  async createClientV3(data) {
    return (
      await this.apiClient.post(baseUrl + "/v3/client", data, {
        errorContext: "Failed to create client",
      })
    )?.data;
  } // createClientV3

  async updateClientV3(clientId, data) {
    return (
      await this.apiClient.patch(baseUrl + "/v3/client/" + clientId, data, {
        errorContext: "Failed to update client",
      })
    )?.data;
  } // updateClientV3

  async uploadClientImageV3(clientId, imageFile) {
    let formData = new FormData();
    formData.append("file", imageFile);

    return (
      await this.apiClient.post(baseUrl + "/v3/client/" + clientId + "/image", formData, {
        errorContext: "Failed to upload image",
      })
    )?.data;
  } // uploadClientImageV3

  async deleteClientImageV3(clientId) {
    return (
      await this.apiClient.delete(baseUrl + "/v3/client/" + clientId + "/image", {
        errorContext: "Failed to delete image",
      })
    )?.data;
  } // deleteClientImageV3

  // CLIENT SUPPLEMENTAL
  async listClientSupplementalV3(params, errorContext = "Failed to get clients") {
    return (
      await this.apiClient.get(baseUrl + "/v3/client-supplemental", {
        params,
        errorContext,
      })
    )?.data;
  } // listClientSupplementalV3

  async createClientSupplementalV3(data, errorContext = "Failed to create client supplemental") {
    return (
      await this.apiClient.post(baseUrl + "/v3/client-supplemental", data, {
        errorContext,
      })
    )?.data;
  } // createClientSupplementalV3

  async updateClientSupplementalV3(
    params,
    data,
    errorContext = "Failed to update client supplemental"
  ) {
    return (
      await this.apiClient.patch(baseUrl + "/v3/client-supplemental", data, {
        params,
        errorContext,
      })
    )?.data;
  } // updateClientSupplementalV3
}

export default ClientService;
